<template>
  <div>
    <p class="text-center">
      ТИ МОЖЕШ СТАТИ ДИКТОРОМ НА RADIOKIDS.ONLINE!
    </p>
    <p>
      Ти маєш гарну дикцію, любиш декламувати вірші та читати казки і тобі ще
      не виповнилося 16? Надсилай на нашу
      <a
        href="mailto:radiokids.online@gmail.com?subject=Диктори"
        v-b-popover.hover.top="'radiokids.online@gmail.com'"
      >
        електронну скриньку
      </a>
      інформацію про себе та аудіофайл у форматі
      MP3 або WAV з начиткою мінімум 1 сторінки тексту. Це можуть бути
      вірші, скоромовки, оповідання, казки тощо.
    </p>

    <div class="paragraph-delimiter"></div>
  </div>
</template>

<script>
export default {
  name: 'SpeakersPage'
}
</script>

<style lang="scss" scoped>
  @import "../../common.scss";
</style>



// WEBPACK FOOTER //
// src/components/Pages/SpeakersPage.vue